import { SvgStyled } from '../../components/Global/Atomics/SvgStyled';

const Cloud_lg = (props) => {
    const width = props.width ? props.width + 'px' : '32px';
    const height = props.height ? props.height + 'px' : '32px';

    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 32 32"
            fill={props.fill ? props.fill : 'none'}
            customColor={props.customColor}
            width={width}
            height={height}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.05911 11.2583C8.96249 8.1584 11.8105 6 15.072 6H16C19.8995 6 23.0606 9.16114 23.0606 13.0606V13.8462H23.4231C26.5031 13.8462 29 16.343 29 19.4231C29 22.5031 26.5031 25 23.4231 25H9.88461C6.08235 25 3 21.9177 3 18.1154V16.8498C3 13.9355 5.21868 11.5393 8.05911 11.2583ZM15.072 8C12.6033 8 10.4608 9.7028 9.90348 12.1078L9.87447 12.233C9.7391 12.8172 9.21869 13.2308 8.61904 13.2308C6.6203 13.2308 5 14.8511 5 16.8498V18.1154C5 20.8131 7.18692 23 9.88461 23H23.4231C25.3986 23 27 21.3986 27 19.4231C27 17.4476 25.3986 15.8462 23.4231 15.8462H22.0606C21.5083 15.8462 21.0606 15.3984 21.0606 14.8462V13.0606C21.0606 10.2657 18.7949 8 16 8H15.072Z"
            />
        </SvgStyled>
    );
};

export default Cloud_lg;
